import React from "react";
import { Terminal } from "../ui/terminal";

// Terminal demo tuned to the embed story — one snippet, live bookings.
export const EmbedTerminal = () => (
  <div className="max-w-3xl mx-auto mb-12 sm:mb-16">
    <Terminal
      title="your-website — install BookingFlows"
      commands={[
        '<script src="https://bookingflows.com/widget.js"></script>',
        "bookingflows init --org trail-blazer-yachts",
        "bookingflows embed services --theme brand",
      ]}
      outputs={{
        0: ["✔ Widget script loaded — 12 kb, async, zero dependencies"],
        1: ["✔ Connected to your BookingFlows account", "✔ 6 experiences synced with live availability"],
        2: ["✔ Booking widget live on your site — brand colors applied", "→ First booking captured 4 minutes later"],
      }}
      typingSpeed={32}
      delayBetweenCommands={900}
    />
  </div>
);
